module.exports = __webpack_public_path__ + "static/media/seminar.67845d77.jpg";